<div class="wrap">
  <div class="title">
    <fa-icon [icon]="getFaIcon('faChevronLeft')" class="back" (click)="back()" appChangeColorTheme attribute="color">
    </fa-icon>

    <h2>Gérer les sessions de l'offre: <i>{{offer?.offerName}}</i></h2>

    <div class="add_offer" *ngIf="!addSession" (click)="showFormSession()">
      <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
      <span>Ajouter une session</span>
    </div>

    <div class="cancel" *ngIf="addSession" (click)="showFormSession()">
      <button>Retour</button>
    </div>

  </div>

  <app-session-form *ngIf="addSession" [offerKey]="offer?.offerKey" [sessionSelected]="sessionSelected"
    [actionFormSession]="actionFormSession" (addSession)="updateAddSession($event)"></app-session-form>
  <app-session-table *ngIf="!addSession && !isLoading" [sessions]="sessions" (addSession)="updateAddSession($event)"
    (sessionSelected)="updateSession($event)"></app-session-table>

  <mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>

</div>